import React from 'react'
import DataTable from 'react-data-table-component';

interface listProps {
    className: any
    columns: any
    data: any
    PdfExport: any
    ExportToExcel: any
    disabled: boolean
    onRowClicked?: any
}

const CustomTable: React.FC<listProps> = ({ className, columns, data = [], PdfExport = false, ExportToExcel = false, disabled, onRowClicked }) => {
    return (
        <>
            <div className="col-lg-12">
                <div className="row form_border table_color py-3">
                    <div className={`col-lg-12 mb-1 table-scrollable ${className}`}>
                        {data &&
                            <DataTable
                                columns={columns}
                                data={data}
                                highlightOnHover
                                pagination
                                paginationPerPage={5}
                                paginationRowsPerPageOptions={[5, 10, 15, 20, 50, 100]}
                                responsive
                                onRowClicked={onRowClicked}
                            />
                        }
                    </div>

                    <div>
                        {
                            typeof PdfExport === 'function' &&
                            <button type='button'
                                disabled={disabled}
                                className='border-0 p-0 bg-transparent me-1 set_disableclr'>
                                <i className="fa fa-file-pdf-o" aria-hidden="true" style={{ fontSize: "28px", color: "red" }}
                                    onClick={PdfExport}>
                                </i>
                            </button>
                        }
                        {
                            typeof ExportToExcel === 'function' &&
                            <button type='button'
                                disabled={disabled}
                                className='border-0 p-0 bg-transparent me-1 set_disableclr'
                            >
                                <i className="fa fa-file-excel-o" aria-hidden="true" style={{ fontSize: "28px", color: "green" }}
                                    onClick={ExportToExcel}>
                                </i>
                            </button>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default CustomTable